import { render, staticRenderFns } from "./NewsCategories.vue?vue&type=template&id=e9ca688a&scoped=true"
import script from "./NewsCategories.vue?vue&type=script&lang=js"
export * from "./NewsCategories.vue?vue&type=script&lang=js"
import style0 from "./NewsCategories.vue?vue&type=style&index=0&id=e9ca688a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ca688a",
  null
  
)

export default component.exports